const mutations = {
  mutationAddProductCategory(state, payload) {
    state.addProductCategory = payload;
  },

  mutationEditProductCategory(state, payload) {
    state.editProductCategory = payload;
  },

  mutationProductCategoryList(state, payload) {
    state.productCategoryList = payload;
  },

  mutationIndustryList(state, payload) {
    state.industryList = payload;
  },

  mutationUploadProgress(state, payload) {
    state.uploadProgress = payload;
  },

  mutationIsNewInsurerCreated(state, payload) {
    state.isNewInsurerCreated = payload;
  },

  mutationSetInsurerDetail(state, payload) {
    state.insurerDetail = payload;
  },

  resetInsurerDetail(state) {
    state.insurerDetail = {};
  },
};

export default mutations;
